import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export function useDebounce(value) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  const _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    debounced = _useState2[0],
    setDebounced = _useState2[1];
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
}